<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import axios from 'axios'
import { useRoute } from 'vue-router'

import { LoadingList } from '@/types/cargo-loading'
import NotFoundComponent from '@/pages/NotFoundComponent.vue'

import LoadingListContent from '@/components/cargo-loading/LoadingListContent.vue'

const route = useRoute()

const loadingLists = ref<LoadingList[]>([])
const loading = ref(false)

async function fetchLoadingLists() {
    loading.value = true
    try {
        const response = await axios.get(
            window.route('cl.loading-lists.show-multiple', {
                'company-id': route.query['company-id'],
                'start-date': route.query['start-date'],
                'end-date': route.query['end-date'],
            }),
        )
        loadingLists.value = response.data.data
    } finally {
        loading.value = false
    }
}

onMounted(() => fetchLoadingLists())
</script>

<template>
    <NotFoundComponent v-if="!route.query['company-id'] || loadingLists.length === 0" />
    <div v-else class="flex flex-col">
        <LoadingListContent
            v-for="list in loadingLists"
            :key="list.id"
            :loading-list="list"
            class="break-before-page"
        />
    </div>
</template>
